//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import speciesSearch from '~/graphql/queries/speciesSearch.gql';

export default {
  props: {
    clearOnAdd: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      species: [],
      searchValue: null,
    };
  },
  watch: {
    searchValue(val) {
      val ? this.fetchSpecies(val) : (this.species = []);
    },
  },
  methods: {
    async fetchSpecies(query) {
      try {
        const {data} = await this.$apollo.query({
          query: speciesSearch,
          variables: {query},
        });
        this.species = data.speciesSearch || [];
      } catch (e) {
        console.error(e);
      }
    },
    highlight(text) {
      const q = this.searchValue.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
      return text.replace(
        new RegExp(q, 'gi'),
        m => `<span class="text-primary-light">${m}</span>`,
      );
    },
    add(item) {
      this.$emit('add', item);
      if (this.clearOnAdd) {
        this.searchValue = '';
      }
    },
  },
};
